import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.booom-video .video-block').forEach(function (block) {
        block.querySelector('.video-trigger').addEventListener('click', function () {
            const source = block.dataset.source;
            const embed  = block.dataset.embed;

            if (!embed) return;

            let player;

            if (source === 'file') {
                player = document.createElement('video');
                player.src      = embed;
                player.autoplay = true;
                player.controls = true;
                player.classList.add('absolute', 'inset-0', 'w-full', 'h-full', 'bg-black');
            } else {
                player = document.createElement('iframe');
                player.src             = embed;
                player.allow           = 'autoplay; fullscreen; picture-in-picture';
                player.allowFullscreen = true;
                player.classList.add('absolute', 'inset-0', 'w-full', 'h-full');
            }

            // Remove thumbnail, overlay and play button; insert player
            block.innerHTML = '';
            block.appendChild(player);
            block.classList.remove('cursor-pointer');
        });
    });
});
